export default __webpack_public_path__ + "static/media/homeLogoDungeonEpics_210.d21c0ce6.png";